var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompetitiveInterest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 50C11.6929 50 0.5 38.8071 0.5 25C0.5 11.1929 11.6929 0 25.5 0C39.3071 0 50.5 11.1929 50.5 25C50.5 38.8071 39.3071 50 25.5 50Z",
    fill: "#27490F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.313 18.5968V15.4416H36.576V18.5968H31.313ZM13.9415 18.5968V15.4416H19.2045V18.5968H13.9415ZM37.2968 14H30.5921C30.194 14 29.8712 14.3227 29.8712 14.7209V19.3178V26.9368C29.8712 29.4802 27.8021 31.5493 25.2587 31.5493C22.7153 31.5493 20.6462 29.4802 20.6462 26.9368V19.3178V14.7209C20.6462 14.3227 20.3235 14 19.9253 14H13.2206C12.8225 14 12.4998 14.3227 12.4998 14.7209V19.3178V26.9368C12.4998 28.2186 12.6903 29.4846 13.066 30.6996C13.1837 31.08 13.5872 31.2927 13.9677 31.1753C14.348 31.0577 14.5609 30.654 14.4434 30.2736C14.1103 29.1967 13.9414 28.074 13.9414 26.9368V20.0385H19.2044V26.9368C19.2044 30.2751 21.9203 32.9909 25.2586 32.9909C28.597 32.9909 31.3129 30.2751 31.3129 26.9368V20.0385H36.5759V26.9368C36.5759 33.1771 31.4989 38.254 25.2586 38.254C21.3156 38.254 17.7165 36.2451 15.6312 32.8802C15.4215 32.5418 14.9773 32.4375 14.6387 32.6472C14.3003 32.8569 14.196 33.3012 14.4057 33.6397C15.5303 35.4544 17.1044 36.9721 18.958 38.0289C20.8706 39.1193 23.0494 39.6958 25.2586 39.6958C32.294 39.6958 38.0176 33.9722 38.0176 26.9369V19.3178V14.7209C38.0177 14.3227 37.695 14 37.2968 14L37.2968 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitiveInterest);
export default __webpack_public_path__ + "static/media/competitive-interest.548e517208c3d2666c9b30ecd13e6c17.svg";
export { ForwardRef as ReactComponent };